export default "__VITE_ASSET__Soc1US3n__"